import React from 'react';
import { Link } from 'react-router-dom';
import products from '../components/products';

const OurProducts = () => {
  return (
    <div className="my-4 py-4" id="ourProducts">
      <h2 className="my-2 text-center text-3xl text-white uppercase font-bold">Our Products</h2>
      <div className="flex justify-center">
        <div className="w-24 border-b-4 border-white mb-8"></div>
      </div>

      <div className="px-4" data-aos="fade-down" data-aos-delay="600">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 relative"
            >
              <div className="m-2 text-justify text-sm">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-48 h-48 object-cover rounded-lg"
                />
                <div className="p-4">
                  <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 min-h-[3rem] text-ellipsis overflow-hidden">
                    {product.title}
                  </h4>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <Link
                  to={`/product/${product.id}`}
                  className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-4 py-2 text-sm shadow-xl rounded-xl"
                >
                  Product Details
                  <svg
                    className="w-4 h-4 ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurProducts;
